export default __webpack_public_path__ + "static/home-page-main-30c6e72806506138b9bd44a2ab31a419.mp4";